export const arkansas = {
  "05000": "Arkansas",
  "05001": "Arkansas County",
  "05003": "Ashley County",
  "05005": "Baxter County",
  "05007": "Benton County",
  "05009": "Boone County",
  "05011": "Bradley County",
  "05013": "Calhoun County",
  "05015": "Carroll County",
  "05017": "Chicot County",
  "05019": "Clark County",
  "05021": "Clay County",
  "05023": "Cleburne County",
  "05025": "Cleveland County",
  "05027": "Columbia County",
  "05029": "Conway County",
  "05031": "Craighead County",
  "05033": "Crawford County",
  "05035": "Crittenden County",
  "05037": "Cross County",
  "05039": "Dallas County",
  "05041": "Desha County",
  "05043": "Drew County",
  "05045": "Faulkner County",
  "05047": "Franklin County",
  "05049": "Fulton County",
  "05051": "Garland County",
  "05053": "Grant County",
  "05055": "Greene County",
  "05057": "Hempstead County",
  "05059": "Hot Spring County",
  "05061": "Howard County",
  "05063": "Independence County",
  "05065": "Izard County",
  "05067": "Jackson County",
  "05069": "Jefferson County",
  "05071": "Johnson County",
  "05073": "Lafayette County",
  "05075": "Lawrence County",
  "05077": "Lee County",
  "05079": "Lincoln County",
  "05081": "Little River County",
  "05083": "Logan County",
  "05085": "Lonoke County",
  "05087": "Madison County",
  "05089": "Marion County",
  "05091": "Miller County",
  "05093": "Mississippi County",
  "05095": "Monroe County",
  "05097": "Montgomery County",
  "05099": "Nevada County",
  "05101": "Newton County",
  "05103": "Ouachita County",
  "05105": "Perry County",
  "05107": "Phillips County",
  "05109": "Pike County",
  "05111": "Poinsett County",
  "05113": "Polk County",
  "05115": "Pope County",
  "05117": "Prairie County",
  "05119": "Pulaski County",
  "05121": "Randolph County",
  "05123": "St. Francis County",
  "05125": "Saline County",
  "05127": "Scott County",
  "05129": "Searcy County",
  "05131": "Sebastian County",
  "05133": "Sevier County",
  "05135": "Sharp County",
  "05137": "Stone County",
  "05139": "Union County",
  "05141": "Van Buren County",
  "05143": "Washington County",
  "05145": "White County",
  "05147": "Woodruff County",
  "05149": "Yell County",
};
